import { colorsPalettes } from "@similarweb/styles";

import { ChartIds } from "pro-features/components/Chart/src/components/annotations/Helpers/ChartIdsHelper";
import { percentageSignFilter } from "app/filters/ngFilters";
import { PopTooltip, PopTooltipSingle } from "app/pages/website-analysis/TrafficAndEngagement/ChartTooltips/ChartTooltips";
import { CompareModeTooltip } from "app/pages/website-analysis/TrafficAndEngagement/ChartTooltips/CommonChartTooltip";
import { GenericGraph } from "app/pages/website-analysis/TrafficAndEngagement/Components/GenericGraph";
import { PopSingleModeLegends } from "app/pages/website-analysis/TrafficAndEngagement/Legends/PopSingleModeLegends";
import {
    tooltipPositioner,
    POPAndCompareTooltipPositioner,
} from "app/pages/website-analysis/TrafficAndEngagement/MD/chartConfig";
import {
    parseData,
    parsePOPCompareModeDataWithMTD,
    parsePOPSingleModeDataWithMTD,
} from "app/pages/website-analysis/TrafficAndEngagement/UtilityFunctionsAndConstants/ParseServerData";
import {
    dateFormatter,
    getChartType,
    getGetExcel,
    getrInitPOPItemsSingleModeWebSources,
    isTimeGranularityDisabled,
    isTimeGranularityDisabledOnlyMonth,
    neverStacking,
    OVERVIEW_EXCEL_ENDPOINT,
    POP_COMPARE_EXCEL_END_POINT,
    POP_SINGLE_CHART_TYPE,
} from "app/pages/website-analysis/TrafficAndEngagement/UtilityFunctionsAndConstants/UtilityFunctions";

const ENDPOINT_METRIC = "BounceRate";

export const getChangeColor = (isDecrease: boolean, isNan: boolean): string =>
    !isNan ? (!isDecrease ? colorsPalettes.red.s100 : colorsPalettes.green.s100) : colorsPalettes.carbon[500];

export const BounceRate = (props) => {
    const {
        name,
        getChartTooltipHeaders,
        meta: { isSingleMode, isPOP },
    } = props;
    let metricData;
    const percentageFormatter = ({ value }) => percentageSignFilter()(value, 2);
    if (!isPOP) {
        const addToDashboardName = "EngagementBounceRate";
        const getChartType = () => "line";
        const getExcelLink = getGetExcel(OVERVIEW_EXCEL_ENDPOINT);
        const getGraphData = parseData;
        const chartTooltip = (props) => (
            <CompareModeTooltip
                {...props}
                tableHeaders={getChartTooltipHeaders(props.timeGranularity)}
                xFormatter={dateFormatter}
                yFormatter={percentageFormatter}
                getChangeColor={getChangeColor}
            />
        );
        metricData = {
            isTimeGranularityDisabled,
            getChartType,
            yAxisLabelsFormatter: percentageFormatter,
            getExcelLink,
            addToDashboardName,
            getGraphData,
            chartTooltip,
            tooltipPositioner,
        };
    } else if (isSingleMode) {
        const addToDashboardName = "EngagementBounceRate";
        const getGraphData = parsePOPSingleModeDataWithMTD;
        const isStacking = () => false;
        const yAxisLabelsFormatter = ({ value }) => percentageSignFilter()(value, 0);
        const getExcelLink = getGetExcel(OVERVIEW_EXCEL_ENDPOINT);
        const getChartType = () => "line";
        const chartType = POP_SINGLE_CHART_TYPE;
        const getWebSourceForApi = ({ webSource }) => webSource;
        const getSites = (props) => getrInitPOPItemsSingleModeWebSources(props);
        const legends = (props) => <PopSingleModeLegends {...props} />;
        const chartTooltip = (props) => (
            <PopTooltipSingle
                pointsData={props.points}
                xFormatter={dateFormatter}
                yFormatter={percentageFormatter}
            />
        );
        metricData = {
            isTimeGranularityDisabled: isTimeGranularityDisabledOnlyMonth,
            getChartType,
            yAxisLabelsFormatter,
            getExcelLink,
            getGraphData,
            getWebSourceForApi,
            hideLegendsData: true,
            getSites,
            legends,
            chartTooltip,
            isStacking,
            addToDashboardName,
            chartType,
            tooltipPositioner,
        };
    } else {
        const yAxisLabelsFormatter = ({ value }) => percentageSignFilter()(value, 0);
        const getExcelLink = getGetExcel(POP_COMPARE_EXCEL_END_POINT);
        const getGraphData = parsePOPCompareModeDataWithMTD;
        const chartTooltip = (props) => (
            <PopTooltip
                pointsData={props.points}
                xFormatter={dateFormatter}
                yFormatter={percentageFormatter}
            />
        );
        const popApiResponseName = "BounceRate";
        metricData = {
            isTimeGranularityDisabled: isTimeGranularityDisabledOnlyMonth,
            getChartType,
            yAxisLabelsFormatter,
            getExcelLink,
            getGraphData,
            chartTooltip,
            popApiResponseName,
            isStacking: neverStacking,
            hideLegendsData: true,
            tooltipPositioner: POPAndCompareTooltipPositioner,
        };
    }
    metricData.endpointMetric = ENDPOINT_METRIC;
    metricData.name = name;
    return (
        <GenericGraph
            metric={metricData}
            {...props}
            chartIdForAnnotations={`${ChartIds["TrafficAndEngagementBounceRate"]}`}
        />
    );
};
